import { ResponseParams, requestHttpGet } from './RequestBase';

export type GetNewsReqData = {
	category?: number;
	title?: string;
	offset?: number; // 取得開始位置 デフォルト先頭
	limit?: number; // 取得数 デフォルト500
};
type GetNewsResData = {
	news_list: News[];
};
export type News = {
	id: string;
	site_cd: string;
	category: number;
	title: string;
	start_date: string;
	end_date: string;
};
// お知らせ一覧取得
export const callGetNewsApi = async (query?: GetNewsReqData): Promise<ResponseParams<GetNewsResData>> => {
	const result: ResponseParams<GetNewsResData> = await requestHttpGet(`/news`, query);
	return result;
};
